import { useState, useCallback, useEffect, useRef } from '@wordpress/element';

const ToastItem = ({ toast, onRemove }) => {
    const timer = useRef(null);
    useEffect(() => {
        timer.current = setTimeout(() => onRemove(toast.id), toast.duration || 4000);
        return () => clearTimeout(timer.current);
    }, [toast.id]);
    const icons = { success: '✓', error: '✕', warning: '⚠', info: 'ℹ' };
    return (
        <div className={`dss-toast dss-toast--${toast.type}`} role="alert">
            <span className="dss-toast__icon">{icons[toast.type] || icons.info}</span>
            <span className="dss-toast__msg">{toast.message}</span>
            <button className="dss-toast__close" onClick={() => onRemove(toast.id)} aria-label="Dismiss">✕</button>
        </div>
    );
};

export const ToastContainer = ({ toasts, onRemove }) => (
    <div className="dss-toast-container" aria-live="polite">
        {toasts.map(t => <ToastItem key={t.id} toast={t} onRemove={onRemove} />)}
    </div>
);

let _id = 0;
export const useToast = () => {
    const [toasts, setToasts] = useState([]);
    const remove = useCallback((id) => setToasts(p => p.filter(t => t.id !== id)), []);
    const show = useCallback((message, type = 'info', duration = 4000) => {
        const id = ++_id;
        setToasts(p => [...p, { id, message, type, duration }]);
    }, []);
    return {
        toasts, removeToast: remove,
        toast: {
            success: (m, d) => show(m, 'success', d),
            error:   (m, d) => show(m, 'error',   d || 6000),
            warning: (m, d) => show(m, 'warning', d),
            info:    (m, d) => show(m, 'info',    d),
        },
    };
};
